import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { User } from '../../../../types/models/user'
import StatsCards from '../StatsCards'
import AdminAccountCard from '../AdminAccountCard'

interface OverviewTabProps {
  users: User[]
  currentUser: User | undefined
  formatDate: (date: string) => string
}

const OverviewTab: React.FC<OverviewTabProps> = ({ users, currentUser, formatDate }) => {
  return (
    <>
      <Row className="mb-4">
        <Col>
          <StatsCards users={users} layout="horizontal" />
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <AdminAccountCard currentUser={currentUser} formatDate={formatDate} />
        </Col>
        <Col md={8}>{/* Future: Add more overview widgets here */}</Col>
      </Row>
    </>
  )
}

export default OverviewTab
